// extracted by mini-css-extract-plugin
export default {"string":"string-5456"};